'use client';

import { useEffect, useState } from 'react';

import Button from '@gds/Button/Button';
import Link from 'next/link';

import styles from '../ReviewHero.module.css';

interface StickyCtaProps {
  strings: Record<string, string>;
  href: string;
}

const StickyCta = ({ strings, href }: StickyCtaProps) => {
  const [hasScrolled, setHasScrolled] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 790 && window.innerWidth >= 1024) {
        setHasScrolled(true);
      } else {
        setHasScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`${styles.fixedCta} ${hasScrolled ? styles.visable : styles.hidden}`}>
      <Link href={href} legacyBehavior passHref prefetch={false}>
        <Button size="small" Component="a">
          {strings.viewCars}
        </Button>
      </Link>
    </div>
  );
};

export default StickyCta;
